<template>
  <pdp-section-heading />
</template>

<script lang="ts" setup>
import PdpSectionHeading from '#commerce/components/pdp/section/Heading.vue'

const { $feature } = useNuxtApp()
const { brandClasses } = useAppConfig().pages.pdp

if ($feature.tempShowATCAboveFold)
  brandClasses.headingPrice = 'mt-4 lg:mt-1 !lg:text-xs'
</script>
